const eBasketErrorMessages = {
  CreditLimitError:
    "Oops! The total cost of this order exceeds the customer's credit limit. You can adjust the credit limit by opening the Manage Customers page on a separate browser tab.",
  OfferUnavailableError:
    "Oops! Some of the offers in this basket are currently not available. To proceed, either delete the item(s) highlighted in red, or re-activate the unavailable offers by opening the Manage Offers page or Manager Customers page on a separate browser tab and try again.",
  OrderRejectedError: "Unable to place order, please try again",
  CreatePriceQuoteError: "Unable to save price quote, please try again",
  InvalidVolumeError:
    "Invalid volume input(s). To continue, please update the volumes in the basket or alternatively click Save Price Quote and update available offer volumes from the Manage Offers page",
  ZeroOrNullVolumeError: "Invalid volume inputs(s). Please update the volumes in the basket to continue",
};

const eBasketStatus = {
  Open: "OPEN",
  Reserved: "RESERVED",
  Ordered: "ORDERED",
};

export {
    eBasketErrorMessages,
    eBasketStatus
};